<template lang="pug">
  b-modal#efightAPILogInfo(
  ref="efightAPILogInfo"
  :title="$t('ui.efight_api_log_info')"
  centered
  no-fade
  no-close-on-backdrop
  :busy="loading"
  ok-only
  @show="reset"
  @shown="shown")
    b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
      b-form-group(:label="$t('ui.id')" disabled).mb-0
        DebounceInput(
          size="sm"
          ref="id"
          type="text"
          v-model="id"
          :disabled="loading"
        )
      b-form-group(:label="$t('ui.video')" disabled).mb-0
        DebounceInput(
          size="sm"
          ref="videoName"
          type="text"
          v-model="videoName"
          :disabled="loading"
        )
      b-form-group(:label="$t('ui.created_on')" disabled).mb-0
        DebounceInput(
          size="sm"
          ref="createdOn"
          type="text"
          v-model="createdOn"
          :disabled="loading"
        )
      b-form-group(:label="$t('ui.request')" disabled).mb-0
        b-form-textarea(v-model="request" rows="7")
      b-form-group(:label="$t('ui.response')" disabled).mb-3
        b-form-textarea(v-model="response" rows="10")
      div.row
        div.col
          b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}
    div(slot="modal-ok")
      SubmitButton(:loading="loading" icon="fas fa-check" :text="$t('ui.ok')" isModal=true)
</template>

<script>
import { required, minLength, maxLength, alphaNum, integer, email, helpers } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";
import beautify from "xml-beautifier";

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput
  },
  props: {
    item: {
      type: Object
    },
  },
  data() {
    return {
      id: "",
      request: "",
      response: "",
      videoName: "",
      createdOn: "",
      loading: false,
      feedback: {
        success: true,
        status: ""
      }
    };
  },
  computed: {
  },
  validations: {
  },
  methods: {
    reset: function() {
      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown: function() {
      this.$v.$reset();
      this.id = this.item.id;
      this.videoName = this.item.video_name;
      this.createdOn = this.$moment(this.item.created_on).format("YYYY-MM-DD, HH:mm:ss");
      this.request = JSON.stringify(JSON.parse(this.item.request), null, 2);
      this.response = JSON.stringify(JSON.parse(this.item.response), null, 2);
    }
  }
};
</script>
